import { styled } from '../styled';
import { Colors } from '../theme';

export const LineStyled = styled('div')(() => ({
  backgroundColor: Colors.blue100,
  height: 1,
  margin: '16px 0',
}));
